// assets/video-popup.js

(function () {
  document.addEventListener('DOMContentLoaded', function () {
    const triggers = document.querySelectorAll('[data-video-popup] .product-video-popup__trigger');
    const header = document.querySelector('.page-header');

    if (!triggers.length) return;

    triggers.forEach(trigger => {
      trigger.addEventListener('click', function () {
        const popupWrapper = trigger.closest('[data-video-popup]');
        if (!popupWrapper) return;

        header.style.zIndex = 5;
        const overlay = popupWrapper.querySelector('[data-popup-overlay]');
        if (!overlay) return;

        overlay.classList.remove('hidden');
      });
    });

    const closeButtons = document.querySelectorAll('[data-popup-close]');

    closeButtons.forEach(button => {
      button.addEventListener('click', function () {
        const overlay = button.closest('[data-popup-overlay]');
        if (!overlay) return;
        header.style.zIndex = 16;
        overlay.classList.add('hidden');

        const video = overlay.querySelector('video');
        if (video) video.pause();
      });
    });
  });
})();
